export default "__VITE_ASSET__8ff76383__"